import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import gsap from "gsap";
import Config from "@/config/Config";
import Facade from "@/Facade";

export default class CurtainContainer extends BaseContainer {

  constructor() {
    super()

    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    // Signals.roundStart.add(this.onRoundStart, this)1

    this.black = new PIXI.Graphics()
    this.black.alpha = 0
    this.addChild(this.black)

    this.onOrientationChanged(Facade.orientation)
  }

  onRoundEnd() {
    gsap.killTweensOf(this.black)
    gsap.to(this.black, 1.8, {alpha: 1})
  }

  onMakeBets() {
    gsap.killTweensOf(this.black)
    gsap.to(this.black, 1, {alpha: 0})
  }

  onOrientationChanged(orientationSymbol) {
    const offset = 400;
    if (this.black) {
      this.black.clear()
    }
    this.black.beginFill(0x000000, 1)
    this.black.drawRect(
      -offset,
      -offset,
      Config.currentPattern.mainMask.width + offset * 2,
      Config.currentPattern.mainMask.height + offset * 2)
    this.black.endFill()
  }

}
